<template>
  <!-- 员工事件管理 -->
  <div>
    <div class="search_wrap">
      <el-form :model="queryParam" ref="form" label-width="90px" :inline="true" size="mini">
        <el-form-item label="专员名称">
          <el-input
            @keyup.enter.native="searchQuery"
            v-model="queryParam.userName"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
        <el-form-item label="指导员姓名">
          <el-input
            @keyup.enter.native="searchQuery"
            v-model="queryParam.gssName"
            placeholder="请输入"
          ></el-input>
        </el-form-item>

        <div class="selectBox">
          <span class="selectText">类型</span>
          <el-select v-model="queryParam.type" size="mini" placeholder="请选择">
            <el-option
              v-for="item in this.options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </div>

        <div class="selectBox">
          <span class="selectText">状态</span>
          <el-select v-model="queryParam.status" size="mini" placeholder="请选择">
            <el-option
              v-for="item in this.statusOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </div>

        <div class="selectBox">
          <span class="selectText">报备日期</span>
          <el-date-picker
            size="mini"
            v-model="happenTime"
            @change="happenTimeDateChange"
            :default-value="dateDefaultShow"
            unlink-panels
            :clearable="true"
            :picker-options="expireTimeOption"
            value-format="yyyy-MM-dd"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          ></el-date-picker>
        </div>

        <el-form-item style="margin-left: 20px">
          <el-button type="primary" @click="searchQuery">查询</el-button>
          <el-button type="default" @click="resetForm">重置</el-button>
          <el-button type="success" @click="handleAdd()">添加</el-button>
        </el-form-item>
      </el-form>
    </div>

    <e-table
      :listLoading="loading"
      :selection="true"
      :tableHeadConfig="columns"
      @pageChange="loadData"
      :paginationData="ipagination"
      :tableLoadData="dataSource"
      @selectLine="onSelectChange"
      :tableRowClassName="tableRowClassName"
    >
      <template #handlerSlot="slotData">
        <el-button
          v-if="slotData.data.row.type === '巡检扣除' && slotData.data.row.status === '待审批'"
          plain
          size="mini"
          type="primary"
          @click="handleExamineApprove(slotData.data.row, false)"
        >审批</el-button>
        <el-button
          v-if="slotData.data.row.type !== '巡检扣除'"
          size="mini"
          type="primary"
          @click="handleEdit(slotData.data.row, false)"
        >编辑</el-button>
        <el-button
          v-if="slotData.data.row.type === '巡检扣除'"
          size="mini"
          type="success"
          @click="handleExamineApprove(slotData.data.row, true)"
        >详情</el-button>
        <el-button
          v-else
          size="mini"
          type="success"
          @click="handleDetail(slotData.data.row, true)"
        >详情</el-button>
      </template>
    </e-table>
    <modal-form ref="modalForm" @ok="modalFormOk"></modal-form>
  </div>
</template>

<script>
import modalForm from "./component/userModal"

import eTable from "@/components/table"
import { listMixin } from "@/mixins/listMixin"
export default {
  components: { eTable, modalForm },
  mixins: [listMixin],
  mounted () {
    this.dateDefaultShow = new Date()
    this.dateDefaultShow.setMonth(new Date().getMonth() - 1)
  },
  updated () {
    this.dataSource.forEach((item) => {
      if (typeof item.type === 'number') item.type = this.typeCode[item.type]
      if (typeof item.status === 'number') item.status = this.statusCode[item.status]
    })
  },
  data () {
    return {
      happenTime: '',
      dateDefaultShow: "",
      expireTimeOption: {
        disabledDate (date) {
          return date.getTime() - 8.64e6 >= Date.now()
        },
      },
      url: {
        list: "/employeeEventRecord/queryPage",
      },
      queryParam: {},
      loading: false,
      options: [
        { value: "", label: "请选择" },
        { value: 1, label: "晚于两日内报备" },
        { value: 2, label: "晚于2个工作日内更新(桶站绑定关系)" },
        { value: 3, label: "人员信息数据错误" },
      ],
      statusOptions: [
        { value: "", label: "请选择" },
        { value: 1, label: "待审批" },
        { value: 2, label: "已通过" },
        { value: 3, label: "已拒绝" },
      ],
      typeCode: {
        1: '晚于两日内报备',
        2: '晚于2个工作日内更新(桶站绑定关系)',
        3: '人员信息数据错误',
        4: '巡检扣除',
      },
      statusCode: {
        1: '待审批',
        2: '已通过',
        3: '已拒绝',
      },
      columns: [
        { field: "userName", label: "专员名称" },
        { field: "type", label: "类型" },
        { field: "status", label: "状态" },
        { field: "createTime", label: "提交日期" },
        { field: "happenTime", label: "报备日期" },
        { field: "gssName", label: "指导员姓名" },
        { field: "entryTime", label: "入职日期" },
        { field: "leaveTime", label: "离职日期" },
        { field: "remark", label: "备注" },
        {
          width: 200,
          label: "操作",
          slotName: "handlerSlot",
          columnType: "slot",
        },
      ],
    }
  },
  methods: {
    happenTimeDateChange (date) {
      if (date) {
        this.queryParam.happenTimeStart = date[0] + " 00:00:00"
        this.queryParam.happenTimeEnd = date[1] + " 23:59:59"
      } else {
        this.queryParam.happenTimeStart = ""
        this.queryParam.happenTimeEnd = ""
      }
    },
    resetForm () {
      this.queryParam = {}
      this.happenTime = ''
      this.searchQuery()
    },
    handleExamineApprove (record, type) {
      this.$refs.modalForm.examineApprove(record, type)
      this.$refs.modalForm.title = '审批'
    }
  },
};
</script>

<style scoped lang="less">
.search_wrap {
  margin: 10px 0;
}
.imgBox {
  width: 150;
  height: 150px;
  border: 1px solid rgb(223, 212, 212);
}
.selectBox {
  margin-bottom: 18px;
  display: inline-block;
  margin-right: 10px;
  vertical-align: top;
}
.selectText {
  width: 80px;
  line-height: 28px;
  font-weight: 700;
  cursor: default;
  float: none;
  display: inline-block;
  text-align: right;
  vertical-align: middle;
  font-size: 14px;
  color: #606266;
  padding: 0 12px 0 0;
  box-sizing: border-box;
}
</style>